import type { InterventionDeleteButtonProps } from "./intervention-delete-button.type";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import { TAB_KEYS, TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { useAuthorization } from "@/modules/authorization";
import { useModelNavigate } from "@/modules/model-navigate";

export const InterventionDeleteButton = ({
  intervention,
  ...buttonProps
}: InterventionDeleteButtonProps) => {
  const { navigateToModel } = useModelNavigate();
  const { canDeleteItem } = useAuthorization();

  if (!canDeleteItem(intervention)) return null;

  const onClick = () => {
    const recommendedBy = intervention.recommended_by;

    if (recommendedBy) {
      const id = recommendedBy.id;
      navigateToModel("intervention", { id, replace: true });
    } else {
      const id = intervention.asset_id;
      const search = `?${TAB_PARAM_KEYS.CONTEXT_TAB_KEY}=${TAB_KEYS.ASSETS_INTERVENTIONS}`;
      navigateToModel("asset", { id, replace: true, search });
    }
  };

  return (
    <DeleteButton
      modelKey="intervention"
      model={intervention}
      onDeleted={onClick}
      buttonProps={buttonProps}
      predicateRemoveKeys={({ queryKey }) =>
        queryKey.includes(intervention.id) &&
        queryKey.includes("recommendations")
      }
    />
  );
};
